import React from 'react';
import clsx from 'clsx';
import { Terminal } from 'api/data/payment/types';

export const ReaderList = ({
  terminals,
  sessionTerminalLoading,
  onClickTerminal,
}: {
  terminals: Terminal[];
  sessionTerminalLoading: boolean;
  onClickTerminal: (terminal: Terminal) => void;
}) => {
  return (
    <div className="box card-terminals-list">
      {terminals.map(terminal => (
        <div key={terminal.id} className="row space-between align-center">
          <div className="row direction-column">
            <span className="subtitle-x-small">{terminal.name}</span>
            <span className="subtitle-xx-small neutral">{terminal.activeSession?.cashierName}</span>
          </div>
          <button
            data-testid={`connect-button-${terminal.id}`}
            className={clsx('button-size-ml font-size-xxxs', {
              'button-outline': !!terminal.activeSession,
            })}
            onClick={() => onClickTerminal(terminal)}
            disabled={sessionTerminalLoading}>
            {sessionTerminalLoading ? 'Loading...' : 'Connect'}
          </button>
        </div>
      ))}
    </div>
  );
};
